import { pushEvent } from '../../client/data-layer';

/**
 * Tracks clicks on product cards.
 */
export const trackKeywordSearchPageProductClick = (
  keyword: string | undefined,
  productId: number | string
) => {
  pushEvent('keywordSearchPageProductClick', {
    keyword,
    productId,
  });
};

/**
 * Tracks clicks on offers.
 */
export const trackKeywordSearchPageOfferClick = (
  keyword: string | undefined,
  offerId: number | string
) => {
  pushEvent('keywordSearchPageOfferClick', {
    keyword,
    offerId,
  });
};

/**
 * Tracks clicks on category links.
 */
export const trackKeywordSearchPageCategoryClick = (
  keyword: string,
  categoryName: string
) => {
  pushEvent('keywordSearchPageCategoryClick', {
    keyword,
    categoryName,
  });
};

/**
 * Tracks all the ids of offers and products without any images.
 */
export const trackKeywordSearchPageNoImages = (
  url: string,
  prodAndOfferIds: string
) => {
  pushEvent('keywordSearchPageNoImages', {
    url,
    prodAndOfferIds,
  });
};

/*
 * Tracks if visited page is offers only
 */
export const trackKeywordSearchPageOffersOnlyVisited = (
  keyword: string,
  pageUrl: string
) => {
  pushEvent('keywordSearchPageOffersOnlyVisited', {
    keyword,
    pageUrl,
  });
};
